import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './scss/style.scss';
import AuthState from './context/auth/AuthState';
ReactDOM.render(
  <React.StrictMode>
    <AuthState>
      <App />
    </AuthState>
  </React.StrictMode>,
  document.getElementById('root')
); 